export class RequisitionsInfiniteScrollContainer {
    constructor(userId, companyId, jobService, alertsAndNotificationsService, isStaffingCompany) {
        this.jobService = jobService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.isStaffingCompany = isStaffingCompany;
        this.userId = userId;
        this.companyId = companyId;
        this.$onInit();
    }
    $onInit() {
        this.requisitions = [];
        this.requisitionsPerPage = [];
        this.busy = false;
        this.loadingSearchButton = false;
        this.requisitionsExistFlag = true;
        this.currentPromise = null;
        this.disableInfiniteScroll = false;
        this.requisitionCount = 0;
        this.isFilterOn = false;
    }
    _getRequisitions(successCallback, errorCallback) {
        this.currentPromise = this.jobService.searchJobsByText(this.userId, this.companyId, this.requisitionsQueryFilter.searchText, this.requisitionsQueryFilter, (data) => {
            if (successCallback) {
                successCallback(data);
            }
        }, (error) => {
            if (errorCallback) {
                errorCallback(error);
            }
        });
    }
    getNext() {
        if (this.busy)
            return;
        this.busy = true;
        if (this.requisitionsQueryFilter.pageNum == '') {
            this.requisitionsQueryFilter.pageNum = 1;
        }
        this._setIsFilterOn();
        this._getRequisitions((data) => {
            if (angular.isDefined(data) && data != 'user cancellation') {
                this.requisitionCount = data.totalCount;
                if (data.jobDetails.length > 0) {
                    angular.forEach(data.jobDetails, (val, key) => {
                        val.requisitionIndex = (this.requisitions.length + 1);
                        this.requisitions.push(val);
                    });
                    if (data.jobDetails.length < this.requisitionsQueryFilter.size) {
                        this.disableInfiniteScroll = true;
                    }
                    else {
                        this.requisitionsQueryFilter.pageNum++;
                    }
                }
                else {
                    this.disableInfiniteScroll = true;
                }
                if (this.requisitions.length > 0) {
                    this.requisitionsExistFlag = true;
                }
                else {
                    this.requisitionsExistFlag = false;
                }
            }
            this.busy = false;
            this.loadingSearchButton = false;
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    getNextPage(currentPage) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        if (this.busy)
            return;
        this.busy = true;
        this.requisitionsQueryFilter.pageNum = currentPage ? currentPage : 1;
        this.requisitionsPerPage = [];
        this._getRequisitions((data) => {
            if (angular.isDefined(data) && data != 'user cancellation') {
                this.requisitionCount = data.totalCount;
                angular.forEach(data.jobDetails, (val, key) => {
                    this.requisitionsPerPage.push(val);
                });
                if (this.requisitionsPerPage.length > 0) {
                    this.requisitionsExistFlag = true;
                }
                else {
                    this.requisitionsExistFlag = false;
                }
            }
            this.busy = false;
            this.loadingSearchButton = false;
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _setIsFilterOn() {
        let filter = this.requisitionsQueryFilter;
        if (filter.clientOrBU.length > 0
            || filter.roleList.length > 0
            || filter.requisitionNums.length > 0
            || filter.recruiters.length > 0
            || filter.requisitionTypes.length > 0
            || filter.jobTypes.length > 0
            || filter.requisitionStates.length > 0
            || filter.searchText.length > 0
            || (!filter.isAssignedToMe && this.isStaffingCompany)
            || (!filter.isAssignedToOthers && this.isStaffingCompany)
            || (!filter.isUnassigned && this.isStaffingCompany)
            || filter.sortColumn !== "" && filter.sortDirection !== ""
            || filter.workLocationIds.length > 0) {
            this.isFilterOn = true;
        }
        else {
            this.isFilterOn = false;
        }
    }
}
//# sourceMappingURL=requisitions-infinite-scroll-container.js.map